// htmlKacis.js — BASKI PENCERELERİNİN HTML KAÇIŞI — TEK KAYNAK (21 Eki 2026, W7)
//
// 🔴 Dört kopya vardı: FTLPanel'in üç baskı penceresi (SKPK paketi, FTL EDIT REPORT, FTL REPORT) yalnız `&` ve `<`
//    kaçırıyordu (`>` eksik); DUTY SHEET'inki `>`'yi de kaçırıyordu ama değeri tırnaklı özniteliğe de yazıyor
//    (`data-gorev="…"`) ve tırnağı kaçırmıyordu — bir metindeki `"` özniteliği kırabilirdi. Ekranda görünen aynıdır.
/** Metni HTML gövdesine ya da tırnaklı özniteliğe güvenle koyar. Boş / null → '—'. */
export const esc = (x) => String(x ?? '—')
  .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
